export default {
    methods: {
        /**
         * @param {{affiliate_url: string, short_url: string}} urls
         * @param {string} widgetName
         **/
        linkWithSysSubs(urls, widgetName) {
            return `${urls.affiliate_url}&sys_sub4=widget-${widgetName}&sys_sub5=widget-market`;
        }
    }
}
